import React from 'react';
import ScoreCard from './ScoreCard';
import MetadataDialog from './MetadataDialog';
import { sendAPIRequest } from 'shared/utils/requests';
import styled from 'styled-components';

const FixedContainer = styled.div`
  @media(min-width: 1080px) {
    position: fixed;
    top: 80px;
    right: 35px;
    width: 480px;
  }
  margin: 0 0 2em 0;
`

const PageContainer = styled.div`
  @media(min-width: 1080px) {
    padding-right: 500px;
    width: 100%;
  }
`

class ScoringPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      events: [],
      customerSkills: [],
      repSkills: [],
      tags: [],
      outcomes: [],
      eventSkills: {},
      selectedOutcomes: new Set(),
      selectedTag: null,
      customerName: '',
      swapSpeakers: false,
      audioUrl: '',
      flags: [],
    }

    let { callId, fnCallId, quizId } = this.props.match.params;
    this.callId = callId;
    this.quizId = quizId;
    this.fnCallId = fnCallId;

    this.toggleEventSkill = this.toggleEventSkill.bind(this);
    this.onTagChange = this.onTagChange.bind(this);
    this.onOutcomeChange = this.onOutcomeChange.bind(this);
    this.onCustomerNameChange = this.onCustomerNameChange.bind(this);
    this.submitScore = this.submitScore.bind(this);
    this.swapSpeakers = this.swapSpeakers.bind(this);
    this.flag = this.flag.bind(this);
  }

  componentDidMount() {
    let scoringData;

    // Get scoring data for this call from backend
    this.fetchScoringData().then(response => {
      scoringData = response.data;

      let eventSkills = {};
      scoringData.events.forEach(event => { eventSkills[event.id] = new Set() });

      this.isQuiz = scoringData.is_quiz;
      if (this.isQuiz) {
        this.quizId = scoringData.quiz_id;
      }

      this.setState({
        company: scoringData.company,
        events: scoringData.events,
        customerSkills: scoringData.customerSkills,
        repSkills: scoringData.repSkills,
        outcomes: scoringData.outcomes,
        tags: scoringData.tags,
        eventSkills: eventSkills,
        callOccurredAt: scoringData.call_occurred_at,
        audioUrl: scoringData.audio_url,
        flags: scoringData.flags,
      });
    });
  }

  swapSpeakers() {
    this.setState(prevState => {
      let events = [...prevState.events];

      for(let event of events) {
        event.isRep = !event.isRep;
      }

      return {events: events, swapSpeakers: !prevState.swapSpeakers};
    });
  }

  toggleEventSkill(eventId, skillId) {
    // Toggle skill for a specified event
    this.setState(prevState => {
      let eventSkills = prevState.eventSkills;
      let selectedSkills = eventSkills[eventId];

      selectedSkills = new Set(selectedSkills);

      if (selectedSkills.has(skillId)) {
        selectedSkills.delete(skillId);
      } else {
        selectedSkills.add(skillId);
      }

      return {
        eventSkills: {...eventSkills, [eventId]: selectedSkills}
      };
    });
  }

  onCustomerNameChange(e) {
    this.setState({
      customerName: e.target.value,
    });
  }

  onOutcomeChange(outcomeId) {
    this.setState(prevState => {
      let selectedOutcomes = new Set(prevState.selectedOutcomes);
      if (selectedOutcomes.has(outcomeId)) {
        selectedOutcomes.delete(outcomeId);
      } else {
        selectedOutcomes.add(outcomeId);
      }
      return {
        selectedOutcomes: selectedOutcomes,
      }
    });
  }

  onTagChange(tagId) {
    this.setState({
      selectedTag: Number(tagId)
    });
  }

  fetchScoringData() {
    return sendAPIRequest(`/qa/api/scoring/${this.callId || this.fnCallId}`, "GET");
  }

  flag(status) {
    return sendAPIRequest(`/calls/${this.callId}/flag`, "POST", {call: {status: status}});
  }

  submitScore() {
    const scoringData = {
      "event_skills": Object.entries(this.state.eventSkills).map(
          ([eventId, selectedSkills]) => ({
            event_id: Number(eventId),
            selected_skills: Array.from(selectedSkills) || [],
          })
        ),
      "outcomes": Array.from(this.state.selectedOutcomes) || [],
      "tag": this.state.selectedTag || null,
      "swap_speakers": this.state.swapSpeakers,
    };

    if(this.fnCallId) {
      scoringData["call_id"] = null;
      scoringData["fn_id"] = Number(this.fnCallId);
      return sendAPIRequest(`/qa/api/scoring/${this.fnCallId}`,
        "POST", scoringData);
    } else if (this.isQuiz) {
      scoringData["quiz_id"] = Number(this.quizId);
      return sendAPIRequest('/qa_quiz/submit_calibration',
        "POST", scoringData);
    } else {
      scoringData["call_id"] = Number(this.callId);
      scoringData["fn_id"] = null;
      return sendAPIRequest(`/qa/api/scoring/${this.callId}`,
        "POST", scoringData);
    }
  }

  render() {
    let {
      events,
      repSkills,
      customerSkills,
      eventSkills,
      company,
      outcomes,
      tags,
      customerName,
      selectedOutcomes,
      selectedTag,
      callOccurredAt,
      audioUrl,
      flags,
    } = this.state;

    return (
      <PageContainer>
        {events.map(event => (
          <ScoreCard
            key={event.id}
            event={event}
            skills={event.isRep ? repSkills : customerSkills}
            selectedSkills={eventSkills[event.id]}
            toggleEventSkill={this.toggleEventSkill}
          />
        ))}
        <FixedContainer>
          <MetadataDialog
            company={company}
            outcomes={outcomes}
            tags={tags}
            customerName={customerName}
            selectedOutcomes={selectedOutcomes}
            selectedTag={selectedTag}
            onTagChange={this.onTagChange}
            onOutcomeChange={this.onOutcomeChange}
            onCustomerNameChange={this.onCustomerNameChange}
            onSubmit={this.submitScore}
            callId={this.callId}
            callOccurredAt={callOccurredAt}
            swapSpeakers={this.swapSpeakers}
            audioUrl={audioUrl}
            flags={flags}
            flagCall={this.flag}
          />
        </FixedContainer>
      </PageContainer>
    );
  }
}

export default ScoringPage;
